// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface Type {
  employee_name: string
  job_position_name: string | null
}

export function useEmployeeDetail(user_id?: number | null): {
  data: Type | null
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/employee/byuserid",
      { params: { userid_id: user_id } }
    ).then((res: SuccessFetch<{
      payload: Type[]
    }>) => {
      setData(res.data.payload[0])
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}